import React, { useState, useEffect }  from "react";
import CartInputField from '../Cart/CartInputField';
import OkPopup from "../OkPopup";


const ProfilePassword = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [showDialog, setShowDialog] = useState(false)

  const [NewPassword, setNewPassword] = useState("");
  const [NewPassword2, setNewPassword2] = useState("");
  const [OldPassword, setOldPassword] = useState("");
  const [ErrorList, setErrorList] = useState([]);
  const [Message, setMessage] = useState("");
  const [OutcomeMessage, setOutcomeMessage] = useState("");

  useEffect(() => {
    setMessage("");    
  }, [NewPassword, NewPassword2, OldPassword]);


  const changePasswordHandler = () => {
    var errList = [];
    const minLen = 6;
    
    if (NewPassword !== NewPassword2) {
      errList.push({id: "newPassword", msg: "La nuova password è diversa da quella di conferma."});
      errList.push({id: "newPassword2", msg: "La nuova password è diversa da quella di conferma."});
    }
    if (NewPassword.trim().length < minLen)
      errList.push({id: "newPassword", msg: "La password deve contenere almeno "+minLen+" caratteri."});
      if (NewPassword2.trim().length < minLen)
      errList.push({id: "newPassword2", msg: "La password deve contenere almeno "+minLen+" caratteri."});
    if (OldPassword.trim().length < minLen)
      errList.push({id: "oldPassword", msg: "La password deve contenere almeno "+minLen+" caratteri."});

    setErrorList(errList);
    //console.log(errList);
  
    if (errList.length > 0) {
      setMessage("La compilazione dei dati è errata. Segui le indicazioni e riprova!");
      return;
    } else {
      setMessage("");
    }

    let params = [
      { name: "id_e_user", value: props.userData.id_e_user },
      { name: "new_psw", value: NewPassword },
      { name: "old_psw", value: OldPassword },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/edit_psw_cliente",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (result) => {
        //console.log(result);
        if (result.status === "true") {
          setOutcomeMessage(result.message);
          setNewPassword("");
          setNewPassword2("");
          setOldPassword("");
          //setMessage("Cambio password riuscito.");
        } else {
          setOutcomeMessage(result.message);
        }
        setShowDialog(true);
        console.log(result);
      }
    );
  };

  const closeAddedDialog = () => {
    setShowDialog(false);
}

  return (
    <div className="dati_utente">
      {showDialog ? (
        <OkPopup
          titletext="Operazione completata"
          text={OutcomeMessage}
          closeHandler={closeAddedDialog}
        />
      ) : null}
      <form autoComplete="off">
        <input type="hidden" autoComplete="off" />

        <p className="test_legenda_form">I campi contrassegnati con asterisco ('*') sono obbligatori.</p>
        <p className="test_legenda_form">La password deve essere di almeno otto caratteri alfanumerici, con almeno una lettera minuscola, una lettera maiuscola e una cifra numerica.</p>

        <CartInputField
          required={true}
          type="password"
          lbl="Nuova Password"
          name="newPassword"
          value={NewPassword}
          change={setNewPassword}
          cssClass="riga_info_cart"
          errList={ErrorList}
          autoComplete="off"
        />
        <CartInputField
          required={true}
          type="password"
          lbl="Conferma Nuova Password"
          name="newPassword2"
          value={NewPassword2}
          change={setNewPassword2}
          cssClass="riga_info_cart"
          errList={ErrorList}
          autoComplete="off"
        />
        <CartInputField
          required={true}
          type="password"
          lbl="Password Attuale"
          name="oldPassword"
          value={OldPassword}
          change={setOldPassword}
          cssClass="riga_info_cart"
          errList={ErrorList}
          autoComplete="off"
        />
      </form>
      {Message.length > 0 ? <p>{Message}</p> : null}

      <button type="button" onClick={() => changePasswordHandler()}>
        Cambia Password
      </button>
    </div>
  );
};

export default ProfilePassword;